import {Injectable, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {
  DateAdapter,
  MAT_DATE_LOCALE,
  MatDatepickerModule,
  MatFormFieldModule, MatInputModule,
  MatNativeDateModule,
  NativeDateAdapter
} from '@angular/material';
import {DatePickerComponent} from './date-picker.component';

@Injectable()
export class MyDateAdapter extends NativeDateAdapter {
  getFirstDayOfWeek(): number {
    return 1;
  }
}

@NgModule({
  imports: [
    CommonModule,
    MatInputModule,
    FormsModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatNativeDateModule
  ],
  exports: [
    DatePickerComponent,
  ],
  declarations: [DatePickerComponent],
  providers: [
    {provide: MAT_DATE_LOCALE, useValue: 'ru-RU'},
    {provide: DateAdapter, useClass: MyDateAdapter},
  ]
})
export class DatePickerModule {
}
